"use client";
import { anatomy } from "@zag-js/checkbox";
//#region src/components/checkbox/checkbox.anatomy.ts
var checkboxAnatomy = anatomy.extendWith("group");
//#endregion
export { checkboxAnatomy };
